import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { EventType } from "../common/Exports";
export var ConsoleLoggingListener = function ConsoleLoggingListener() {
  var _this = this;

  var logLevelFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EventType.Warning;

  _classCallCheck(this, ConsoleLoggingListener);

  this.onEvent = function (event) {
    if (event.eventType >= _this.privLogLevelFilter) {
      var log = _this.toString(event);

      switch (event.eventType) {
        case EventType.Debug:
          // tslint:disable-next-line:no-console
          console.debug(log);
          break;

        case EventType.Info:
          // tslint:disable-next-line:no-console
          console.info(log);
          break;

        case EventType.Warning:
          // tslint:disable-next-line:no-console
          console.warn(log);
          break;

        case EventType.Error:
          // tslint:disable-next-line:no-console
          console.error(log);
          break;

        default:
          // tslint:disable-next-line:no-console
          console.log(log);
          break;
      }
    }
  };

  this.toString = function (event) {
    var logFragments = ["".concat(event.EventTime), "".concat(event.Name)];

    for (var prop in event) {
      if (prop && event.hasOwnProperty(prop) && prop !== "eventTime" && prop !== "eventType" && prop !== "eventId" && prop !== "name" && prop !== "constructor") {
        var value = event[prop];
        var valueToLog = "<NULL>";

        if (value !== undefined && value !== null) {
          if (typeof value === "number" || typeof value === "string") {
            valueToLog = value.toString();
          } else {
            valueToLog = JSON.stringify(value);
          }
        }

        logFragments.push("".concat(prop, ": ").concat(valueToLog));
      }
    }

    return logFragments.join(" | ");
  };

  this.privLogLevelFilter = logLevelFilter;
};